(() => {
  const place = (root) => {
    const toggle = root.querySelector('[data-wba-toggle]');
    const panel = root.querySelector('.wb-acct__panel');
    if (!toggle || !panel) return;
    const r = toggle.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return;
    panel.style.top = Math.round(r.bottom + 10) + 'px';
    const width = panel.offsetWidth || 320;
    const left = Math.min(
      Math.max(8, Math.round(r.right - width)),
      Math.max(8, window.innerWidth - width - 8)
    );
    panel.style.left = left + 'px';
    panel.style.right = 'auto';
  };

  const bind = (root) => {
    if (root.dataset.wbaBound) return;
    root.dataset.wbaBound = 'true';

    const toggle = root.querySelector('[data-wba-toggle]');
    const panel = root.querySelector('.wb-acct__panel');
    if (!toggle || !panel) return;

    let shutTimer;

    const open = () => {
      clearTimeout(shutTimer);
      panel.classList.remove('is-shut');
      place(root);
      void panel.offsetWidth;
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    };

    const close = () => {
      if (!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      clearTimeout(shutTimer);
      shutTimer = setTimeout(() => {
        panel.classList.add('is-shut');
      }, 200);
    };

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      if (root.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    });

    document.addEventListener('click', (e) => {
      if (!root.classList.contains('is-open')) return;
      if (root.contains(e.target)) return;
      close();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !root.classList.contains('is-open')) return;
      close();
      toggle.focus();
    });

    window.addEventListener('scroll', () => {
      if (root.classList.contains('is-open')) place(root);
    }, { passive: true });

    window.addEventListener('resize', () => {
      if (root.classList.contains('is-open')) place(root);
    }, { passive: true });
  };

  const init = () => {
    document.querySelectorAll('[data-wba-root]').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
